export default __webpack_public_path__ + "static/media/contact.7f767a7b.png";